import "./App.css";
import { RoutesPath } from "./Routes";

function App() {
  return (
    <div className="App">
      <RoutesPath />
    </div>
  );
}

export default App;
